export enum FeedbackEvents {
  TYPEFORM_SEEN = 'typeform_seen',
  TYPEFORM_OPENED = 'typeform_opened',
  TYPEFORM_FINISHED = 'typeform_finished',
  TYPEFORM_CLOSED = 'typeform_closed',
}
